export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Site Genel',
    route: null,
    icon: 'GlobeIcon',
    children: [
      {
        title: 'Site Menü',
        route: 'SiteMenus',
        resource: 'ADMIN_SITE_MENU',
        action: 'read',
      },
      {
        title: 'Carousel',
        route: 'Carousel',
        resource: 'ADMIN_CAROUSEL',
        action: 'read',
      },
      {
        title: 'Sabit İçerikler',
        route: 'Contents',
        resource: 'ADMIN_CONTENTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kurumsal',
    route: null,
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Tarihçe & Hakkımızda',
        route: 'About',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'Sosyal Sorumluluk',
        route: 'SocialProjects',
        resource: 'ADMIN_SOCIAL_PROJECTS',
        action: 'read',
      },
      {
        title: 'Deneyim',
        route: 'AboutCounters',
        resource: 'ADMIN_ABOUT_COUNTERS',
        action: 'read',
      },
      {
        title: 'Sertifikalar',
        route: 'Certificates',
        resource: 'ADMIN_CERTIFICATES_LIST',
        action: 'read',
      },
      {
        title: 'İletişim',
        route: 'Contacts',
        resource: 'ADMIN_CONTACT',
        action: 'read',
      },
    ],
  },
  {
    title: 'Laboratuvar',
    route: 'Services',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Görüntüle',
        route: 'Lab',
        resource: 'ADMIN_LAB',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ürünler',
    route: 'Products',
    icon: 'LayersIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'ProductsAdd',
        resource: 'ADMIN_PRODUCTS',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Products',
        resource: 'ADMIN_PRODUCTS',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'ProductCategories',
        resource: 'ADMIN_PRODUCT_CATEGORIES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Blog',
    route: 'Blog',
    icon: 'BookIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'BlogAdd',
        resource: 'ADMIN_BLOG',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Blog',
        resource: 'ADMIN_BLOG',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'BlogCategories',
        resource: 'ADMIN_BLOG_CATEGORIES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Dil Çeviri',
    route: null,
    icon: 'FlagIcon',
    children: [
      {
        title: 'Çeviri Listesi',
        route: 'Translate',
        resource: 'ADMIN_TRANSLATE',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ayarlar',
    route: null,
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Genel Yapılandırma',
        route: 'Configs',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SEO Yapılandırma',
        route: 'Components',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SMTP',
        route: 'Smtp',
        resource: 'ADMIN_SMTP',
        action: 'read',
      },
      {
        title: 'Önbellek Yönetimi',
        route: 'CacheParams',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
    ],
  },
]
